import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OwnerProfileGuestService } from '../owner-profile-guest.service';
import { OwnerProfileGuest } from '../owner-profile-guest';
import { OwnerProfileService } from '@app/_components/owner-profile/owner-profile.service';

@Component({
    selector: 'app-owner-profile-guest',
    templateUrl: './owner-profile-guest.component.html',
    styleUrls: ['./owner-profile-guest.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OwnerProfileGuestComponent implements OnInit {
    relationships: any;
    ownerProfiles: any;
    ownerProfileIdRequired: boolean;

	constructor(
		private ownerProfileService: OwnerProfileService,
		private primengConfig: PrimeNGConfig,
		private ownerProfileGuestService: OwnerProfileGuestService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.ownerProfileGuest = data.ownerProfileGuest,
			this.statuses = ownerProfileGuestService.statuses;
			this.relationships = ownerProfileGuestService.relationships;
	}

	@Input() ownerProfileGuest: OwnerProfileGuest;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	ownerProfileGuestId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'ownerProfileGuestId': [],
		'firstName': [],
		'lastName': [],
		'emailAddress': [],
		'mobile': [],
		'opsNotes': [],
		'relationship': [],
		'ownerProfileId': [],
	};

	ngOnInit() {
		this.fetchOwnerProfiles();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole ownerProfileGuest object
		if (this.ownerProfileGuest) {
			this.ownerProfileGuestId = this.ownerProfileGuest.ownerProfileGuestId;
			this.fixDates();
			this.form1.patchValue(this.ownerProfileGuest);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.ownerProfileGuestId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			
			if(this.form1.value.ownerProfileId == null && this.form1.value.ownerProfileId == undefined && this.form1.value.ownerProfileId == "undefined"){
				this.form1.value.ownerProfileId = this.ownerProfiles;
			}
			if(this.form1.value.ownerProfileId == null){
				this.ownerProfileIdRequired = true;
				this.messageService.add({ severity: 'error', summary: 'Validation Error', detail: "Owner profile is required" });
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.ownerProfileGuestService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ownerProfileGuest = res.data.ownerProfileGuest;
						this.doAdd.emit(this.ownerProfileGuest);
					},
					(err: any) => {
						console.log('ownerProfileGuest-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('ownerProfileGuest: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.ownerProfileGuestService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ownerProfileGuest = res.data.ownerProfileGuest;
						this.doUpdate.emit(this.ownerProfileGuest);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.ownerProfileGuestService.delete(this.ownerProfileGuest.ownerProfileGuestId)
				.subscribe(
					(res: any) => {
						console.log('ownerProfileGuest-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.ownerProfileGuest);
					},
					(err: any) => {
						console.log('ownerProfileGuest-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			ownerProfileGuestId: [this.ownerProfileGuestId],
			firstName: [],
			lastName: [],
			emailAddress: [],
			mobile: [],
			opsNotes: [],
			relationship: [],
			ownerProfileId: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.ownerProfileGuest.ownerProfileGuestDate = moment(this.ownerProfileGuest.ownerProfileGuestDate).toDate();
	}
	
	fetchOwnerProfiles() {
		if (!this.ownerProfiles || this.ownerProfiles === undefined || this.ownerProfiles.length < 1) {
			try {
				this.ownerProfileService.findAll()
					.subscribe(
						res => {
							console.log('findAllActivityProvidersSummary: ' + JSON.stringify(res));
							this.ownerProfiles = res.data.ownerProfiles;
							return this.ownerProfiles;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.ownerProfiles);
		}
	}
	
	selectOwnerProfile(){
		this.ownerProfileIdRequired = false;
	}
}
